import { useState } from 'react';
import { App } from '@back4app2/sdk';
import { DsButton } from '../ds';
import { RollbackIcon } from '../ds/icons';
import { canRunAppActions } from '../MyAppActions';
import { getAppStatusSummary } from '../../utils/appStatus';
import RollbackDialog from './RollbackDialog';

/**
 * "Instant Rollback" on the Overview head, where Vercel puts it: the same
 * rollback as the Action menu's "Roll back to previous", one click from the
 * screen that shows what is live.
 *
 * Only while the app is Available. A rollback goes from the live deployment
 * to the one before it, and an app with no live deployment — URL expired,
 * deploy failed, still deploying — has nothing to roll back FROM: the server
 * answers NO_PREVIOUS and the dialog would open on "No deployment is live
 * yet". Those apps redeploy instead. Not drawn either for someone who can't
 * deploy, like the Action menu.
 */
const InstantRollbackButton = ({ app }: { app: App }) => {
  const [isOpen, setIsOpen] = useState(false);

  if (!canRunAppActions(app) || getAppStatusSummary(app).tone !== 'ok') {
    return null;
  }

  return (
    <>
      <DsButton
        variant="outline"
        size="lg"
        ariaLabel="Instant rollback"
        onClick={() => setIsOpen(true)}
      >
        <RollbackIcon size={16} />
        <span className="hidden sm:inline">Instant rollback</span>
      </DsButton>
      <RollbackDialog appId={app.id} open={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};

export default InstantRollbackButton;
